<script setup lang="ts">
import { computed } from 'vue';
import PlusIcon from '@/assets/icons/shared/plus.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';
import UiSpinner from '@/modules/ui/components/ui/UiSpinner.vue';

const { variant = 0, title = 'core.add' } = defineProps<{
  variant?: 0 | 1;
  loading?: boolean;
  noIcon?: boolean;
  noTitle?: boolean;
  title?: string;
}>();

const VARIANTS = [
  {
    size: 'm',
    color: 'yellow',
    mode: 'fill',
  },
  {
    size: 's',
    color: 'gray',
    mode: 'outline',
  },
] as const;

const params = computed(() => VARIANTS[variant]);
</script>

<template>
  <UiButton
    :size="params.size"
    :color="params.color"
    :mode="params.mode"
    :disabled="loading"
  >
    <UiSpinner
      v-if="loading"
      v-prefix="noTitle ? null : params.size"
      color="white"
    />

    <PlusIcon
      v-else-if="!noIcon"
      v-prefix="noTitle ? null : params.size"
    />

    <span v-if="!noTitle">{{ $t(title) }}</span>
  </UiButton>
</template>
